import { State } from '@viome/viome-base/src/usecase/Home/Home.model';
import { TimelineProgressBar } from './TrackingProgressBar';

interface TrackingSampleTimelineProps {
  steps: State[];
  currentStepId: number;
  hasIssue: boolean;
  errorText?: string;
  'data-testid'?: string;
  subHeaderExplanation?: string;
}

export const Timeline = ({
  steps,
  currentStepId,
  hasIssue,
  errorText = '',
  'data-testid': testId,
  subHeaderExplanation,
}: TrackingSampleTimelineProps) => {
  return (
    <div className="relative space-y-0" data-testid={testId}>
      {steps
        .filter((step) => !hasIssue || step.id <= currentStepId)
        .map((step, index, filteredSteps) => (
          <TimelineProgressBar
            key={step.id}
            id={step.id}
            text={step.text}
            subHeaderExplanation={subHeaderExplanation}
            currentStepId={currentStepId}
            hasIssue={hasIssue}
            isLastStep={index === filteredSteps.length - 1}
            errorText={errorText}
            data-testid={testId ? `${testId}-step-${step.id}` : undefined}
          />
        ))}
    </div>
  );
};
